// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-title {\n  overflow: hidden;\n  color: rgba(0, 0, 0, 0.85);\n  font-weight: 500;\n  font-size: 16px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  margin-bottom: 8px;\n}\n.modal-meta {\n  font-size: 16px;\n  color: rgba(0, 0, 0, 0.45);\n}\n", ""]);
// Exports
module.exports = exports;
